import OrderOptimizerPotentialDriversList, {
  OrderOptimizerPotentialDriversListItem,
} from "../../../../../../../common/services/order-optimizer/potential-drivers-list/order-optimizer-potential-drivers-list";
import { OrderOptimizerTaxiDetailsHiddenDetailsDriverListItem } from "../types/order-optimizer-taxi-details-hidden-details-driver-list";

const createPotentialDriverListItem = (
  item: OrderOptimizerPotentialDriversListItem
): OrderOptimizerTaxiDetailsHiddenDetailsDriverListItem => {
  return {
    driver: item.driver,
    taxiDriverAssociationUuid: item.taxiDriverAssociationUuid,
    saDistance: item.saDistance,
    taxiCorporation: item.taxiCorporation,
  };
};

const createPotentialDriverList = (
  response: OrderOptimizerPotentialDriversList
): OrderOptimizerTaxiDetailsHiddenDetailsDriverListItem[] => {
  return response.map(createPotentialDriverListItem);
};

const orderOptimizerTaxiDetailsHiddenDetailsDriverListFactory = {
  createPotentialDriverList,
};

export default orderOptimizerTaxiDetailsHiddenDetailsDriverListFactory;
